module.exports = __webpack_public_path__ + "media/pages/assets/images/calendar/2018/january-e420a55749a31901c0702bc2b78a5084.png";